<template>
    <div>
        <BaseSwitch
            v-model="customer.customer_type"
            :labelLeft="$t('form_customer_v2.main_information.label_professional_customer')"
            :label="$t('form_customer_v2.main_information.label_individual_customer')"
        />
        <input type="hidden" name="customer_type" :value="customer.customer_type" />
    </div>
</template>

<script>
import BaseSwitch from '../../Shared/BaseSwitch.vue'
export default {
    props: ['customer'],
    components: { BaseSwitch },
    mounted() {
        this.emitCustomerTypeChange()
    },
    methods: {
        emitCustomerTypeChange() {
            this.$emit('customer-type-changed', {
                customer_type: this.customer.customer_type,
            })
        },
    },
    watch: {
        'customer.customer_type'(newVal) {
            this.emitCustomerTypeChange()
        },
    },
}
</script>
